import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'app-logo-box',
  standalone: true,
  imports: [RouterLink, CommonModule],
  template: ` <a class="logo" style="background-color: #ffffff !important;" (click)="refreshPage($event)">
  <span class="logo-light">
    <span class="logo-lg">
      <img src="assets/caregenix/images/logo/svg-carevance-hori-logo.svg" alt="logo" />
    </span>
    <span class="logo-sm">
      <img src="assets/caregenix/images/logo/png-favi-carvance.png" alt="small logo" />
    </span>
  </span>

  <span class="logo-dark">
    <span class="logo-lg">
      <img src="assets/caregenix/images/logo/svg-carevance-hori-logo.svg" alt="dark logo" />
    </span>
    <span class="logo-sm">
      <img src="assets/caregenix/images/logo/png-favi-carvance.png" alt="small logo" />
    </span>
  </span>
</a>`,
})
export class LogoBoxComponent {
  refreshPage(event: Event) {
  event.preventDefault(); // prevent routerLink or default <a> behavior
  event.stopPropagation();
  window.location.reload(); // refresh the current page
}
}
